module.exports = __webpack_public_path__ + "img/pubmedlogo.11200149.png";